import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=951d9e9c&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('951d9e9c')) {
      api.createRecord('951d9e9c', component.options)
    } else {
      api.reload('951d9e9c', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=951d9e9c&", function () {
      api.rerender('951d9e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/Modal.vue"
export default component.exports